import { useEffect, useState } from "react";

/**
 * A plain <img> that never shows the browser's broken-image icon.
 *
 * This is the generic protection for CMS images whose file is genuinely gone. If the image fails to load, it renders
 * `fallback` instead: a ReactNode (typically the shared <ImageFallback/> placeholder or a text label), or nothing
 * (`fallback="hide"`, for decorative images that sit on a styled background). It is NOT a substitute for fixing storage —
 * it only stops a missing file from looking like a rendering bug — and it never invents a product-specific replacement.
 * Resets when `src` changes, so replacing the image in Admin gets a fresh attempt.
 */
export default function SafeImg({ fallback = "hide", onError, ...img }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [img.src]);
  if (failed) return fallback === "hide" ? null : fallback;
  return <img {...img} onError={(e) => { setFailed(true); if (onError) onError(e); }} />;
}
